export const getListValue = (list, selectedList, key = 'value') => selectedList.map((selectedValue) => {
  const target = list.find((item = {}) => String(item[key]) === String(selectedValue));
  return target;
});

export const formatCategory = ({ id: value = '', name: label = '' }) => ({
  label,
  value,
});
